var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap mx-0"},[(!_vm.selectedWaTemplate)?_c('TemplatesPicker',{attrs:{"inbox-id":_vm.inboxId},on:{"onSelect":_vm.pickTemplate}}):_c('TemplateParser',{attrs:{"template":_vm.selectedWaTemplate},on:{"resetTemplate":_vm.onResetTemplate,"sendMessage":_vm.onSendMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }